{
  "name": "matida-admin-frontend",
  "version": "2.9.8",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port=4202",
    "build:prod": "ng build --configuration=production",
    "build:staging": "ng build --configuration=staging",
    "build:testing": "ng build --configuration=testing",
    "build:development": "ng build --configuration=development --verbose",
    "build:local": "ng build --configuration=local",
    "test": "ng test",
    "test-ci": "ng test --karma-config=src/karma-ci.conf.js --no-progress --code-coverage",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "i18n:extract": "ngx-translate-extract --input ./src --output ./src/assets/i18n/{en,ru}.json --key-as-default-value --sort --clean --format json --format-indentation ' '",
    "prepare": "husky",
    "release": "npx release-it"
  },
  "engines": {
    "node": "^18.18.0 || ^20.9.0 || >=22.0.0"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.2.14",
    "@angular/cdk": "^18.2.14",
    "@angular/common": "^18.2.14",
    "@angular/compiler": "^18.2.14",
    "@angular/core": "^18.2.14",
    "@angular/forms": "^18.2.14",
    "@angular/google-maps": "^18.2.14",
    "@angular/material": "^18.2.14",
    "@angular/material-luxon-adapter": "^18.2.14",
    "@angular/platform-browser": "^18.2.14",
    "@angular/platform-browser-dynamic": "^18.2.14",
    "@angular/router": "^18.2.14",
    "@babel/runtime": "^7.29.7",
    "@ng-select/ng-select": "^13.9.1",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@sentry/angular": "^8.55.2",
    "@stomp/rx-stomp": "^2.4.0",
    "@stomp/stompjs": "^7.3.0",
    "@types/google.maps": "^3.65.5",
    "angularx-qrcode": "^18.0.2",
    "bootstrap": "^4.6.2",
    "file-saver": "^2.0.5",
    "get-contrast": "^3.0.0",
    "html2canvas": "^1.4.1",
    "jspdf": "^2.5.2",
    "luxon": "^3.7.2",
    "mqtt": "^5.15.1",
    "ngx-clipboard": "^16.0.0",
    "ngx-color-picker": "^18.0.0",
    "ngx-currency": "^18.0.0",
    "ngx-img-cropper": "^14.0.1",
    "ngx-pagination": "^6.0.3",
    "ngx-print": "^1.5.1",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "tz-lookup": "^6.1.25",
    "uuid": "^11.0.0",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-builders/custom-esbuild": "^18.0.0",
    "@angular-devkit/build-angular": "~18.2.14",
    "@angular-eslint/builder": "^18.4.3",
    "@angular-eslint/eslint-plugin": "^18.4.3",
    "@angular-eslint/eslint-plugin-template": "^18.4.3",
    "@angular-eslint/schematics": "^18.4.3",
    "@angular-eslint/template-parser": "^18.4.3",
    "@typescript-eslint/eslint-plugin": "^8.0.0",
    "@typescript-eslint/parser": "^8.0.0",
    "@angular/cli": "^18.2.14",
    "@angular/compiler-cli": "^18.2.14",
    "@biesbjerg/ngx-translate-extract": "^7.0.4",
    "@sentry/esbuild-plugin": "^5.4.0",
    "@types/jasmine": "^6.0.0",
    "@types/jasminewd2": "^2.0.13",
    "@types/luxon": "^3.7.1",
    "@types/node": "^20.0.0",
    "acorn": "^8.8.2",
    "buffer": "^6.0.3",
    "eslint": "^8.17.0",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-jsdoc": "^63.0.1",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "husky": "^9.1.7",
    "ini": "^7.0.0",
    "jasmine-core": "^6.2.0",
    "jasmine-spec-reporter": "^7.0.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.0.3",
    "karma-coverage-istanbul-reporter": "~3.0.2",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.2.0",
    "lint-staged": "^15.5.2",
    "prettier": "^3.8.3",
    "process": "^0.11.10",
    "release-it": "^17.11.0",
    "ts-node": "^10.9.2",
    "typescript": "~5.4.5",
    "url": "^0.11.4",
    "webpack": "^5.107.2"
  },
  "lint-staged": {
    "*.{js,ts,css,scss,html}": "prettier --write"
  },
  "release-it": {
    "git": {
      "tagName": null,
      "requireCleanWorkingDir": false,
      "requireUpstream": false,
      "commitMessage": "Release v${version}"
    },
    "npm": {
      "publish": false
    }
  },
  "overrides": {
    "babel-loader": "^8.3.0",
    "@ng-select/ng-select": {
      "@angular/common": "$@angular/common",
      "@angular/core": "$@angular/core",
      "@angular/forms": "$@angular/forms",
      "tslib": "$tslib"
    },
    "ngx-img-cropper": {
      "tslib": "$tslib"
    },
    "@angular/material-luxon-adapter": {
      "@angular/common": "$@angular/common",
      "@angular/core": "$@angular/core",
      "@angular/forms": "$@angular/forms",
      "tslib": "$tslib",
      "@angular/material": "$@angular/material",
      "luxon": "$luxon"
    }
  }
}
